import { all, put, takeEvery, race, take } from 'redux-saga/effects'
import _ from 'lodash'

import { sendMessage } from '../helpers'

import { getFavourites } from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/FavouritesContent/actions'

import {
    ADD_TO_FAVOURITES_REQUEST_SUCCESS,
    REMOVE_FROM_FAVOURITES_REQUEST_SUCCESS,
} from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/FavouritesContent/constants'

import { changeEntityStackTab } from '../../../scenes/Gnosus/components/EntityStack/actions'

import { REFRESH_FAVOURITES, LOAD_FAVOURITES_REQUEST_SUCCESS, LOAD_FAVOURITES_REQUEST_FAILED } from './constants'
import { SOCKET_ON_MESSAGE, SOCKET_ACTION_TYPE } from '../constants'

function* onMessageFromOld(_action) {
    const type = _.get(_action, 'data.type', null)

    if (type === REFRESH_FAVOURITES) {
        const result = yield all({
            response: race({
                success: take(LOAD_FAVOURITES_REQUEST_SUCCESS),
                failed: take(LOAD_FAVOURITES_REQUEST_FAILED),
            }),
            request: put(getFavourites()),
        })

        if (result.response.success) {
            yield put(changeEntityStackTab('favourites'))
        }
    }

    return null
}

function* wsRefreshFavouritesCallSaga() {
    yield sendMessage(SOCKET_ACTION_TYPE.REFRESH_FAVOURITES, {})

    return null
}

export default function* favouritesSaga() {
    yield all([
        takeEvery(SOCKET_ON_MESSAGE, onMessageFromOld),
        takeEvery(ADD_TO_FAVOURITES_REQUEST_SUCCESS, wsRefreshFavouritesCallSaga),
        takeEvery(REMOVE_FROM_FAVOURITES_REQUEST_SUCCESS, wsRefreshFavouritesCallSaga),
    ])
}
